import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ModeEditRounded } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

function Header({
  isEditing,
  handleSave,
  handleCancel,
  handleClickModify,
  isModified,
}) {
  const { classes } = useStyles();

  return (
    <Box
      height={64}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={3}
      py={2}>
      <Typography variant="h6">Role Access</Typography>
      {isEditing ? (
        <Box display="flex" alignItems="center" gap={2}>
          <Button variant="text" color="primary" onClick={handleCancel}>
            <span className={classes.gradientText}>Cancel</span>
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={!isModified}>
            Save
          </Button>
        </Box>
      ) : (
        <Button
          variant="contained"
          color="primary"
          startIcon={<ModeEditRounded />}
          onClick={handleClickModify}>
          Modify Role
        </Button>
      )}
    </Box>
  );
}

export default Header;
